import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { scopoSocialeRules } from './scopo-sociale.rules';

export const scopoSocialeAllRules: FormGroupRules = {
    ...scopoSocialeRules,
};

export const scopoSocialeFormValidators = Object.values(scopoSocialeAllRules);
